export default "__VITE_ASSET__4fe2cca9__$_?nuxt_component=async__"